import React from "react";

const spaceDisplay = props => (
  <div style={props.style}>
    <div style={{ display: "grid", paddingTop:'3px',paddingBottom:'3px' }}>
      <div>
        <span style={{ float: "left" }}>{props.left}</span>
        <span
          style={{
            float: "right"
          }}
        >
          {props.right}
        </span>
      </div>
    </div>
  </div>
);

export default spaceDisplay;



// WEBPACK FOOTER //
// ./src/components/SpaceDisplay/SpaceDisplay.jsx